import { render, staticRenderFns } from "./send-url-success.vue?vue&type=template&id=9a12b796"
import script from "./send-url-success.vue?vue&type=script&lang=js"
export * from "./send-url-success.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports